import FullWidthBannerBlock from './fullWidthBannerBlock'

export default FullWidthBannerBlock
